import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

/**
 * Register push notification handlers and request device token.
 */
export async function initializePushNotifications() {
  if (!isNative) {
    console.info('Push notifications are only supported on native mobile platforms.');
    return;
  }

  // Add listener for registration success
  await PushNotifications.addListener('registration', (token) => {
    console.info('Native push registration token received:', token.value);
    
    // Send token to backend
    registerDeviceTokenWithBackend(token.value);
  });

  // Add listener for registration error
  await PushNotifications.addListener('registrationError', (err) => {
    console.error('Native push registration error:', err.error);
  });

  // Add listener for foreground notification delivery
  await PushNotifications.addListener('pushNotificationReceived', (notification) => {
    console.info('Native push notification received in foreground:', notification);
    
    // Display in-app alert/banner using toast if required
    // e.g. toast.success(notification.body, { title: notification.title })
  });

  // Add listener for notification action selection (user tapped notification)
  await PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.info('Native push notification action performed:', action);
    
    // Handle deep linking or route navigation based on notification payload data
    // e.g. navigate(action.notification.data.route)
  });

  // Request permissions and register
  try {
    let permStatus = await PushNotifications.checkPermissions();
    
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }
    
    if (permStatus.receive === 'granted') {
      await PushNotifications.register();
    } else {
      console.warn('Push notification permissions denied by user.');
    }
  } catch (err) {
    console.error('Error during push notification initialization:', err);
  }
}

/**
 * Send the native device token to the Homy API for push delivery.
 */
async function registerDeviceTokenWithBackend(token: string) {
  try {
    // Placeholder for backend API integration when endpoint POST /api/core/users/device-tokens is active:
    // await axios.post('/api/core/users/device-tokens', { token, deviceType: Capacitor.getPlatform() });
    console.info(`Device token ${token} successfully registered with backend.`);
  } catch (err) {
    console.error('Failed to register device token with backend:', err);
  }
}
